import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (sessionStorage.getItem("staging-banner-dismissed") === "true") {
      this.element.remove()
    }
  }

  dismiss() {
    sessionStorage.setItem("staging-banner-dismissed", "true")
    this.element.remove()
  }
}
